import React from 'react';
import { motion } from 'framer-motion';
import './AboutRUK.css';
import Navbar from '../../components/Homepage/Navbar/Navbar';
import Footer from '../../components/Homepage/Footer/Footer';

const AboutRUK = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  const headerVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  return (
    <div id="aboutRUK-page" className="aboutRUK-page">
      <Navbar />
      
      <motion.div 
        id="aboutRUK-container"
        className="aboutRUK-container"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <motion.div id="aboutRUK-page-header" className="aboutRUK-page-header" variants={headerVariants}>
          <h1 id="aboutRUK-main-title" className="aboutRUK-main-title">About Rayalaseema University Kurnool</h1>
          <div id="aboutRUK-header-underline" className="aboutRUK-header-underline"></div>
        </motion.div>
        
        <motion.div id="aboutRUK-sections" className="aboutRUK-sections" variants={containerVariants}>
          
          {/* Kurnool - The Gateway Section */}
          <motion.section id="aboutRUK-kurnool-section" className="aboutRUK-section" variants={itemVariants}>
            <div id="aboutRUK-kurnool-header" className="aboutRUK-section-header">
              <h2 id="aboutRUK-kurnool-title" className="aboutRUK-section-title">Kurnool - The Gateway of Rayalaseema</h2>
            </div>
            <div id="aboutRUK-kurnool-content" className="aboutRUK-section-content">
              <div id="aboutRUK-geographic-card" className="aboutRUK-content-card">
                <h3 id="aboutRUK-geographic-title" className="aboutRUK-card-title">Unique Geographic Location</h3>
                <p className="aboutRUK-card-text">
                  Kurnool is the only city in India that is located between two rivers: Tungabhadra and Handri. 
                  The District of Kurnool is the Gateway of Rayalaseema, bordered with Mahaboob Nagar District 
                  of Telangana in the North, Anantapur and Kadapa Districts in the South, Bellary District of 
                  Karnataka in the West, and Prakasam District in the East. Kurnool City is located at a distance 
                  of 200 km from Hyderabad City.
                </p>
              </div>
              
              <div id="aboutRUK-historical-card" className="aboutRUK-content-card">
                <h3 id="aboutRUK-historical-title" className="aboutRUK-card-title">Historical Significance</h3>
                <p className="aboutRUK-card-text">
                  Kurnool was earlier called Kandenavolu, which meant "the town of grease." Legend has it that 
                  in the twelfth century, the Odderas were carting stones for the construction of the 
                  Navabrahmeswara temple at Alampur and before they could cross the Tungabhadra, the local 
                  villagers gave the men grease to apply on their cart wheels. Kandenavolu, in course of time, 
                  came to be known as Kurnool.
                </p>
              </div>

              <div id="aboutRUK-stats-card" className="aboutRUK-content-card aboutRUK-stats-card">
                <h3 id="aboutRUK-stats-title" className="aboutRUK-card-title">District Statistics</h3>
                <div id="aboutRUK-stats-grid" className="aboutRUK-stats-grid">
                  <div className="aboutRUK-stat-item">
                    <span className="aboutRUK-stat-number">14</span>
                    <span className="aboutRUK-stat-label">Assembly Constituencies</span>
                  </div>
                  <div className="aboutRUK-stat-item">
                    <span className="aboutRUK-stat-number">2</span>
                    <span className="aboutRUK-stat-label">Parliament Constituencies</span>
                  </div>
                  <div className="aboutRUK-stat-item">
                    <span className="aboutRUK-stat-number">54</span>
                    <span className="aboutRUK-stat-label">Revenue Mandals</span>
                  </div>
                  <div className="aboutRUK-stat-item">
                    <span className="aboutRUK-stat-number">40,46,601</span>
                    <span className="aboutRUK-stat-label">Population (2011 Census)</span>
                  </div>
                  <div className="aboutRUK-stat-item">
                    <span className="aboutRUK-stat-number">61.13%</span>
                    <span className="aboutRUK-stat-label">Literacy Rate</span>
                  </div>
                  <div className="aboutRUK-stat-item">
                    <span className="aboutRUK-stat-number">1000:984</span>
                    <span className="aboutRUK-stat-label">Male-Female Ratio</span>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>

          {/* University Establishment Section */}
          <motion.section id="aboutRUK-establishment-section" className="aboutRUK-section" variants={itemVariants}>
            <div id="aboutRUK-establishment-header" className="aboutRUK-section-header">
              <h2 id="aboutRUK-establishment-title" className="aboutRUK-section-title">Establishment of Rayalaseema University</h2>
            </div>
            <div id="aboutRUK-establishment-content" className="aboutRUK-section-content">
              <div id="aboutRUK-foundation-card" className="aboutRUK-content-card">
                <h3 id="aboutRUK-foundation-title" className="aboutRUK-card-title">Foundation & Vision</h3>
                <p className="aboutRUK-card-text">
                  Rayalaseema University, Kurnool, came into existence, fulfilling the long-cherished dream of 
                  people of Kurnool district in the year 2008, by Act No. 29 of 2008 enacted by the Legislature 
                  of the State of Andhra Pradesh and published in the Andhra Pradesh Gazette on 24 September 2008. 
                  The establishment is part of the Government of Andhra Pradesh's vision to promote access, equity, 
                  and inclusiveness in Higher Education.
                </p>
              </div>

              <div id="aboutRUK-development-card" className="aboutRUK-content-card">
                <h3 id="aboutRUK-development-title" className="aboutRUK-card-title">Historical Development</h3>
                <p className="aboutRUK-card-text">
                  The Postgraduate Centre at Kurnool was started by Sri Venkateswara University in 1977 with a view 
                  to imparting higher education especially to the rural youth of the backward District of Kurnool 
                  in the drought-prone region of Rayalaseema. The University established the Postgraduate Centre 
                  with two courses: Economics with specialization in Area Planning and Regional Development, and 
                  Operations Research and Statistical Quality Control to cater to industry needs.
                </p>
              </div>

              <div id="aboutRUK-timeline-card" className="aboutRUK-timeline-card">
                <h3 id="aboutRUK-timeline-title" className="aboutRUK-card-title">Key Milestones</h3>
                <div id="aboutRUK-timeline" className="aboutRUK-timeline">
                  <div className="aboutRUK-timeline-item">
                    <div className="aboutRUK-timeline-year">1977</div>
                    <div className="aboutRUK-timeline-content">Postgraduate Centre established by Sri Venkateswara University</div>
                  </div>
                  <div className="aboutRUK-timeline-item">
                    <div className="aboutRUK-timeline-year">1979</div>
                    <div className="aboutRUK-timeline-content">Added Physics and Chemistry courses</div>
                  </div>
                  <div className="aboutRUK-timeline-item">
                    <div className="aboutRUK-timeline-year">1985</div>
                    <div className="aboutRUK-timeline-content">Department of Telugu established</div>
                  </div>
                  <div className="aboutRUK-timeline-item">
                    <div className="aboutRUK-timeline-year">1990</div>
                    <div className="aboutRUK-timeline-content">Shifted to University-owned building at B.Tandrapadu</div>
                  </div>
                  <div className="aboutRUK-timeline-item">
                    <div className="aboutRUK-timeline-year">2000</div>
                    <div className="aboutRUK-timeline-content">Added Computer Science, Management, and Mathematics</div>
                  </div>
                  <div className="aboutRUK-timeline-item">
                    <div className="aboutRUK-timeline-year">2008</div>
                    <div className="aboutRUK-timeline-content">Rayalaseema University officially established</div>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>

          {/* Vision & Mission Section */}
          <motion.section id="aboutRUK-vision-section" className="aboutRUK-section" variants={itemVariants}>
            <div id="aboutRUK-vision-header" className="aboutRUK-section-header">
              <h2 id="aboutRUK-vision-title" className="aboutRUK-section-title">Vision, Mission & Core Values</h2>
            </div>
            <div id="aboutRUK-vision-content" className="aboutRUK-section-content">
              <div id="aboutRUK-vision-card" className="aboutRUK-content-card aboutRUK-vision-card">
                <h3 id="aboutRUK-vision-subtitle" className="aboutRUK-card-title">Our Vision</h3>
                <p className="aboutRUK-card-text">
                  To achieve national distinction for creativity, innovation and excellence, and become through 
                  leadership in teaching, research, scholarship, and social action a great leader in higher 
                  education and contribute to the building of a more humane, just, and sustainable world.
                </p>
              </div>

              <div id="aboutRUK-mission-card" className="aboutRUK-content-card aboutRUK-mission-card">
                <h3 id="aboutRUK-mission-subtitle" className="aboutRUK-card-title">Our Mission</h3>
                <p className="aboutRUK-card-text">
                  Rayalaseema University is committed to the highest standards of academic excellence and human 
                  values. The University is devoted to the pursuit of knowledge, wisdom, discovery, and creativity. 
                  It fosters personal and intellectual growth to prepare students for productive careers, meaningful 
                  lives, and responsible citizenship in a global society. The University adheres to the core values 
                  of respect, compassion and social responsibility.
                </p>
              </div>

              <div id="aboutRUK-values-card" className="aboutRUK-content-card aboutRUK-values-card">
                <h3 id="aboutRUK-values-subtitle" className="aboutRUK-card-title">Core Values</h3>
                <div id="aboutRUK-values-grid" className="aboutRUK-values-grid">
                  <div className="aboutRUK-value-item">
                    <h4 className="aboutRUK-value-title">Excellence</h4>
                    <p className="aboutRUK-value-text">Attain excellence in knowledge and skill in all endeavors</p>
                  </div>
                  <div className="aboutRUK-value-item">
                    <h4 className="aboutRUK-value-title">Accountability</h4>
                    <p className="aboutRUK-value-text">Develop a sense of accountability towards community, society and the nation</p>
                  </div>
                  <div className="aboutRUK-value-item">
                    <h4 className="aboutRUK-value-title">Innovation</h4>
                    <p className="aboutRUK-value-text">Accept global challenges and offer high quality education competitively</p>
                  </div>
                  <div className="aboutRUK-value-item">
                    <h4 className="aboutRUK-value-title">Opportunity</h4>
                    <p className="aboutRUK-value-text">Provide every opportunity to faculty, staff, students and community to excel</p>
                  </div>
                  <div className="aboutRUK-value-item">
                    <h4 className="aboutRUK-value-title">Student-Centric</h4>
                    <p className="aboutRUK-value-text">Transition from teacher-centric to learner-centric approach</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>

          {/* Commitment Section */}
          <motion.section id="aboutRUK-commitment-section" className="aboutRUK-section" variants={itemVariants}>
            <div id="aboutRUK-commitment-header" className="aboutRUK-section-header">
              <h2 id="aboutRUK-commitment-title" className="aboutRUK-section-title">Our Commitment</h2>
            </div>
            <div id="aboutRUK-commitment-content" className="aboutRUK-section-content">
              <div id="aboutRUK-commitment-card" className="aboutRUK-content-card aboutRUK-commitment-card">
                <h3 id="aboutRUK-commitment-subtitle" className="aboutRUK-card-title">Constitutional Mandate</h3>
                <p className="aboutRUK-card-text">
                  Rayalaseema University strives constantly to sustain and enhance its quality in teaching, research, 
                  and extension and outreach activities. The University has set itself a unique goal: comprehensive 
                  development and growth of the underprivileged. The University upholds Article 46 of the Constitution 
                  of India: "The State shall promote, with special care, the education and economic interests of the 
                  weaker sections of the people and shall protect them from social injustice and all forms of social 
                  exploitation."
                </p>
              </div>
            </div>
          </motion.section>

        </motion.div>
      </motion.div>
      
      <Footer />
    </div>
  );
};

export default AboutRUK;